// This file is generated automatically by `scripts/build/fp.js`. Please, don't change it.
import fn from '../../setWeekYear/index.js';
import convertToFP from '../_lib/convertToFP/index.js';
var setWeekYearWithOptions = convertToFP(fn, 3);
export default setWeekYearWithOptions;


//////////////////
// WEBPACK FOOTER
// ./~/date-fns/esm/fp/setWeekYearWithOptions/index.js
// module id = 984
// module chunks = 0